import { useEffect, useRef, useState } from "react";

export const usePlaceholderHeightChange = (placeholderHeight, config, adLoadCallback) => {

	const [adLoaded, setAdLoaded] = useState(false);
	const [wrapperHeight, setWrapperHeight] = useState(placeholderHeight);
	const wrapperRef = useRef(null);
	const adRef = useRef(null);

	useEffect(() => {
		//@ts-ignore
		const googletag = window.googletag;

		if (!googletag || !googletag.cmd) {
			return;
		}

		let listener;

		googletag.cmd.push(() => {
			listener = (event) => {
				if (event.slot.getSlotElementId() !== config.id) {
					return;
				}

				// slotRenderEnded fires on every render for this slot, including
				// refreshes. A refresh that comes back empty removes the creative,
				// so the loaded state has to fall back too - otherwise the wrapper
				// keeps its ad-sized height and the sticky close button keeps
				// hovering over an empty slot.
				if (event.isEmpty) {
					setAdLoaded(false);
					setWrapperHeight(placeholderHeight);
					return;
				}

				setAdLoaded(true);
				adLoadCallback && adLoadCallback(config.id)
			};

			googletag.pubads().addEventListener("slotRenderEnded", listener);
		});

		return () => {
			if (listener && googletag.pubads) {
				googletag.pubads().removeEventListener("slotRenderEnded", listener);
			}
		};
	}, []);

	useEffect(() => {
		if (!adLoaded || !placeholderHeight || !adRef.current || !wrapperRef.current) {
			return;
		}

		// GPT sizes the ad iframe asynchronously after slotRenderEnded, so keep the
		// wrapper height synced to the ad's real height. Each update animates via
		// the CSS `transition: height`, growing smoothly from the placeholder.
		const syncHeight = () => {
			if (wrapperRef.current && wrapperRef.current.scrollHeight > 0) {
				setWrapperHeight(wrapperRef.current.scrollHeight);
			}
		};

		syncHeight();

		//@ts-ignore
		if (typeof ResizeObserver === "undefined") {
			return;
		}

		//@ts-ignore
		const observer = new ResizeObserver(syncHeight);
		observer.observe(adRef.current);

		return () => observer.disconnect();
	}, [adLoaded]);

	return {
		wrapperRef,
		wrapperHeight,
		adLoaded,
		adRef,
	}
}


// WEBPACK FOOTER //
// ./src/components/GoogleAd/hooks/usePlaceholderHeightChange.ts